import {
  UseMutationOptions,
  UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError } from 'common/repositories/common.model';

import { ResolveApprovalInput, ResolveApprovalResult } from './model';

export function usePatchResolve(
  options?: UseMutationOptions<
    ResolveApprovalResult,
    ApiError,
    ResolveApprovalInput
  >,
): UseMutationResult<ResolveApprovalResult, ApiError, ResolveApprovalInput> {
  return useMutation<ResolveApprovalResult, ApiError, ResolveApprovalInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `${body.type}/${body.id}/resolve`,
        method: 'PATCH',
      });
    },
    options,
  );
}
